import "date-fns";
import React, { useContext, useEffect } from "react";
import { map } from "ramda";
import { makeStyles, InputLabel } from "@material-ui/core";
import { Grid, FormControl, Select, MenuItem } from "@material-ui/core";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import LoadingButton from "LoadingButton";
import ReportsCard from "ReportsCard";
import TooltipCheckbox from "TooltipCheckbox";
import {UserContext} from "./UserContext";

const useStyles = makeStyles((theme) => ({
  reportDetailsCard: {
    position: "relative",
    // height: 321,
  },
  root: {
    paddingLeft: 20,
    paddingRight: 20,
  },
  exportButton: {
    width: 120,
    height: 40,
    marginBottom: 30,
  },
  reportSelect: {
    width: "100%",
  },
  dateSelect: {
    marginTop: 25,
    marginBottom: 25,
  },
  optionSelect: {
    marginBottom: 25,
  },
  infoIcon: {
    color: theme.palette.primary.main,
    marginTop: 5,
    marginLeft: 5,
  },
  monthlyLabel: {
    whiteSpace: "nowrap",
  },
  tooltipWidth: {
    maxWidth: 300,
  },
  datePicker: {
    minWidth: 130,
    width: "100%",
  },
}));

const minReportDate = new Date("2016-01-01");
const monthlyTooltipText = `Only available when multiple months are selected.`;
const consortiaTooltipText = `Include the organization name in each record. Only available for consortia.`;

const ReportsDetailsPicker = (props) => {
  const classes = useStyles();
  const { user } = useContext(UserContext);

  useEffect(() => {
    console.log(user);
  }, [user]);

  return (
    <ReportsCard
      cardLabel="REPORT DETAILS"
      className={classes.reportDetailsCard}
    >
      <Grid container direction="column" className={classes.root}>
        <Grid item>
          <FormControl className={classes.reportSelect}>
            <InputLabel>Report Type</InputLabel>
            <Select
              value={props.report}
              onChange={(e) => props.onReportChange(e.target.value)}
            >
              {map(
                ({ id, name }) => (
                  <MenuItem key={id} value={id}>
                    {name}
                  </MenuItem>
                ),
                props.reportTypes
              )}
            </Select>
          </FormControl>
        </Grid>
        <Grid
          container
          item
          direction="row"
          alignItems="flex-end"
          spacing={1}
          className={classes.dateSelect}
        >
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Grid item xs>
              <KeyboardDatePicker
                className={classes.datePicker}
                margin="normal"
                id="startDate"
                label="Start Date"
                format="MM/dd/yyyy"
                disableFuture={true}
                minDate={minReportDate}
                value={props.startDate}
                onChange={(date) => props.onStartDateChange(date)}
                KeyboardButtonProps={{
                  "aria-label": "start date",
                }}
              />
            </Grid>
            <Grid item xs>
              <KeyboardDatePicker
                className={classes.datePicker}
                margin="normal"
                id="endDate"
                label="End Date"
                format="MM/dd/yyyy"
                disableFuture={true}
                minDate={minReportDate}
                value={props.endDate}
                onChange={(date) => props.onEndDateChange(date)}
                KeyboardButtonProps={{
                  "aria-label": "end date",
                }}
              />
            </Grid>
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid
          item
          container
          xs
          direction="row"
          wrap="nowrap"
          alignItems="center"
          justify="flex-end"
          className={classes.optionSelect}
        >

          <TooltipCheckbox
            checkboxLabel="Monthly Breakdown"
            tooltip={monthlyTooltipText}
            onChange={(e) => props.onIncludeMonthsChange(e.target.checked)}
            checked={props.includeMonths}
            disabled={props.disableIncludeMonths}
          />

          {!props.disableConsortiaReport && (
              <TooltipCheckbox
                  checkboxLabel="Consortia Grouping"
                  tooltip={consortiaTooltipText}
                  onChange={(e) => props.onConsortiaGroupChange(e.target.checked)}
                  checked={props.isConsortiaReport}
                  disabled={props.disableConsortiaReport}
              />
          )}

        </Grid>
        <Grid item align="right">
          <LoadingButton
            variant="contained"
            disableElevation
            className={classes.exportButton}
            onClick={props.onExportClick}
            disabled={props.disableExport}
            showLoading={props.showLoading}
          >
            EXPORT
          </LoadingButton>
        </Grid>
      </Grid>
    </ReportsCard>
  );
};

export default ReportsDetailsPicker;
